import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import Player from "./player";
import { initAnalytics } from "./helper/analytics";
initAnalytics();
var container = document.getElementById("root");
var root = createRoot(container);
root.render(_jsx(Player, {}));
